import React, { useEffect, useState } from 'react';
import { useContracts } from '../../hooks/useContract';
import { useNotify } from '../../context/NotificationContext';
import { ButtonSpinner } from '../common/Loader';
import { parseError } from '../../utils/errors';
import { shortAddress } from '../../utils/format';

export const WalletManagement = () => {
  const { storageR, storageW } = useContracts();
  const notify = useNotify();

  const [team, setTeam] = useState(null);
  const [liq, setLiq]   = useState(null);
  const [adm, setAdm]   = useState(null);

  const [newTeam, setNewTeam] = useState('');
  const [newLiq, setNewLiq]   = useState('');
  const [newAdm, setNewAdm]   = useState('');
  const [newAdmin, setNewAdmin] = useState('');
  const [newOwner, setNewOwner] = useState('');
  const [newLogic, setNewLogic] = useState('');
  const [newAuthAdmin, setNewAuthAdmin] = useState('');

  const [busy, setBusy] = useState(null);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!storageR) return;
      try {
        const [t, l, a] = await Promise.all([
          storageR.teamWallet(),
          storageR.liquidityWallet(),
          storageR.adminWallet()
        ]);
        if (cancelled) return;
        setTeam(t); setLiq(l); setAdm(a);
      } catch (e) {}
    };
    load();
    return () => { cancelled = true; };
  }, [storageR, reload]);

  const run = async (label, fn) => {
    setBusy(label);
    try {
      const tx = await fn();
      notify.info(`${label}: submitted`);
      await tx.wait();
      notify.success(`${label}: success`);
      setReload((r) => r + 1);
    } catch (e) {
      notify.error(parseError(e));
    } finally { setBusy(null); }
  };

  return (
    <div>
      <div className="card mb-24">
        <div className="section-title">Wallets</div>
        <div className="kv-list mb-24">
          <div className="kv-row"><span className="kv-key">Team Wallet</span><span className="kv-val">{team ? shortAddress(team, 8) : '—'}</span></div>
          <div className="kv-row"><span className="kv-key">Liquidity Wallet</span><span className="kv-val">{liq ? shortAddress(liq, 8) : '—'}</span></div>
          <div className="kv-row"><span className="kv-key">Admin Wallet</span><span className="kv-val">{adm ? shortAddress(adm, 8) : '—'}</span></div>
        </div>

        <div className="admin-form-grid">
          <div>
            <div className="input-group">
              <label className="input-label">New Team Wallet</label>
              <input className="input" placeholder="0x..." value={newTeam} onChange={(e) => setNewTeam(e.target.value)} />
            </div>
            <button className="btn btn-secondary btn-sm" disabled={busy === 'team' || !newTeam} onClick={() => run('team', () => storageW.setTeamWallet(newTeam))}>
              {busy === 'team' && <ButtonSpinner />}Set
            </button>
          </div>
          <div>
            <div className="input-group">
              <label className="input-label">New Liquidity Wallet</label>
              <input className="input" placeholder="0x..." value={newLiq} onChange={(e) => setNewLiq(e.target.value)} />
            </div>
            <button className="btn btn-secondary btn-sm" disabled={busy === 'liq' || !newLiq} onClick={() => run('liq', () => storageW.setLiquidityWallet(newLiq))}>
              {busy === 'liq' && <ButtonSpinner />}Set
            </button>
          </div>
          <div>
            <div className="input-group">
              <label className="input-label">New Admin Wallet</label>
              <input className="input" placeholder="0x..." value={newAdm} onChange={(e) => setNewAdm(e.target.value)} />
            </div>
            <button className="btn btn-secondary btn-sm" disabled={busy === 'adm' || !newAdm} onClick={() => run('adm', () => storageW.setAdminWallet(newAdm))}>
              {busy === 'adm' && <ButtonSpinner />}Set
            </button>
          </div>
        </div>
      </div>

      <div className="card mb-24">
        <div className="section-title">Role Management</div>
        <div className="admin-form-grid">
          <div>
            <div className="input-group">
              <label className="input-label">Set Admin (role)</label>
              <input className="input" placeholder="0x..." value={newAdmin} onChange={(e) => setNewAdmin(e.target.value)} />
            </div>
            <button className="btn btn-secondary btn-sm" disabled={busy === 'roleAdm' || !newAdmin} onClick={() => run('roleAdm', () => storageW.setAdmin(newAdmin))}>
              {busy === 'roleAdm' && <ButtonSpinner />}Set Admin
            </button>
          </div>
          <div>
            <div className="input-group">
              <label className="input-label">Transfer Ownership</label>
              <input className="input" placeholder="0x..." value={newOwner} onChange={(e) => setNewOwner(e.target.value)} />
            </div>
            <button className="btn btn-danger btn-sm" disabled={busy === 'owner' || !newOwner} onClick={() => run('owner', () => storageW.transferOwnership(newOwner))}>
              {busy === 'owner' && <ButtonSpinner />}Transfer
            </button>
          </div>
          <div>
            <div className="input-group">
              <label className="input-label">Set Authorized Logic</label>
              <input className="input" placeholder="0x..." value={newLogic} onChange={(e) => setNewLogic(e.target.value)} />
            </div>
            <button className="btn btn-gold btn-sm" disabled={busy === 'logic' || !newLogic} onClick={() => run('logic', () => storageW.setAuthorizedLogic(newLogic))}>
              {busy === 'logic' && <ButtonSpinner />}Set Logic
            </button>
          </div>
          <div>
            <div className="input-group">
              <label className="input-label">Set Authorized Admin</label>
              <input className="input" placeholder="0x..." value={newAuthAdmin} onChange={(e) => setNewAuthAdmin(e.target.value)} />
            </div>
            <button className="btn btn-gold btn-sm" disabled={busy === 'authAdm' || !newAuthAdmin} onClick={() => run('authAdm', () => storageW.setAuthorizedAdmin(newAuthAdmin))}>
              {busy === 'authAdm' && <ButtonSpinner />}Set Admin Contract
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
